module.exports = __webpack_public_path__ + "img/invoice-de-male-be.b6a65333.png";